var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100% !important"}},[_c('div',{staticClass:"my-5",staticStyle:{"width":"320px"},attrs:{"id":"qr-code-full-region"}})])
}]

export { render, staticRenderFns }